function firstLetter() {
    var text = $(".single-town:first-of-type").find("p").text(),
        span = "<span class='first-letter'>" + text[0] + "</span>";

    if ($(window).width() < 768) {
        $(".single-town:first-of-type").find(".wsw").prepend(span);
    } else {
        $(".single-town:first-of-type").find(".text-cont").prepend(span);
    }
}

firstLetter();

